module.exports = __webpack_public_path__ + "static/media/icofont.ea6b50ee.eot";